<!-- eslint-disable max-len -->
<template>
  <div class="d-flex align-items-start">
    <img
      v-if="useDragIcon"
      src="@/assets/new-form-ui/dragged.svg"
      class="icon-drag"
    >

    <!-- Field Single & Dynamic Attachment Preview -->
    <div
      v-if="column.type === 'single_attachment' || column.type === 'multiple_attachment_dynamic'"
      class="field-preview"
    >
      <div
        :class="{'w-100': !useDragIcon}"
        class="input-preview attachment-preview">
        <img
          class="mr-2"
          src="@/assets/new-form-ui/attachment.svg"
        >
        <span>Document 1</span>
      </div>
    </div>

    <!-- Field Multiple Attachment Preview -->
    <div
      v-else-if="column.type === 'attachment'"
      class="field-preview"
    >
      <div v-if="column.config">
        <div
          v-for="(config, index) in column.config.list_options"
          :key="`config-${config}-${index}`"
          :class="{'w-100': !useDragIcon}"
          class="input-preview attachment-preview">
          <img
            class="mr-2"
            src="@/assets/new-form-ui/attachment.svg"
          >
          <span>{{ config }}</span>
        </div>
      </div>
      <div v-else>
        <div
          :class="{'w-100': !useDragIcon}"
          class="input-preview attachment-preview"
        >
          <img
            class="mr-2"
            src="@/assets/new-form-ui/attachment.svg"
          >
          <span>Document 1</span>
        </div>
        <div
          :class="{'w-100': !useDragIcon}"
          class="input-preview attachment-preview"
        >
          <img
            class="mr-2"
            src="@/assets/new-form-ui/attachment.svg"
          >
          <span>Document 2</span>
        </div>
      </div>
    </div>

    <!-- Field Toggle Preview -->
    <div
      v-else-if="column.type === 'toggle'"
      class="field-preview"
    >
      <j-toggle
        :disabled="true"
        class="toggle-preview"
      />
    </div>

    <!-- Field Checkbox Preview -->
    <div
      v-else-if="column.type === 'checkbox'"
      class="field-preview"
    >
      <div v-if="column.config">
        <div
          v-for="config in column.config.list_options_object"
          :key="config.value"
          class="form-group checkbox-preview"
        >
          <input
            :id="`checkbox-${config.value}`"
            type="checkbox"
            disabled="true"
          >
          <label :for="`checkbox-${config.value}`">
            {{ config.label }}
          </label>
        </div>
      </div>
      <div v-else>
        <div
          v-for="index in 2"
          :key="index"
          class="form-group checkbox-preview"
        >
          <input
            :id="`checkbox${index}`"
            type="checkbox"
            disabled="true"
          >
          <label :for="`checkbox${index}`">
            {{ `Option ${index}` }}
          </label>
        </div>
      </div>
    </div>

    <!-- Field Radio Preview -->
    <div
      v-else-if="column.type === 'radio'"
      class="field-preview"
    >
      <div v-if="column.config">
        <div
          v-for="config in column.config.list_options_object"
          :key="config.value"
          class="form-group checkbox-preview"
        >
          <input
            :id="`radio-${config.value}`"
            type="radio"
            disabled="true"
          >
          <label :for="`radio-${config.value}`">
            {{ config.label }}
          </label>
        </div>
      </div>
      <div v-else>
        <div
          v-for="index in 2"
          :key="index"
          class="form-group checkbox-preview"
        >
          <input
            :id="`radio${index}`"
            type="radio"
            disabled="true"
          >
          <label :for="`radio${index}`">
            {{ `Option ${index}` }}
          </label>
        </div>
      </div>
    </div>

    <!-- Timer -->
    <div
      v-else-if="column.type === 'timer'"
      class="field-preview"
    >
      <div class="timer-preview">
        <div class="btn-timer btn-play">
          <img src="@/assets/new-form-ui/play-blue.png">
        </div>
        <div class="btn-timer btn-stop">
          <img src="@/assets/new-form-ui/stop.png">
        </div>

        <span>00:00:00</span>
      </div>
    </div>

    <!-- Color -->
    <div
      v-else-if="column.type === 'color'"
      class="field-preview"
    >
      <div class="color-preview">
        <div
          v-for="index in 10"
          :key="index"
          :class="`color color-${index}`"
        />
      </div>
    </div>

    <!-- Field Maps Preview -->
    <div
      v-else-if="column.type === 'location'"
      class="field-preview"
    >
      <div
        :class="{'w-100': !useDragIcon}"
        class="input-preview text-preview"
      >
        <span>{{ `${column.placeholder || ''}` }}</span>
      </div>

      <div
        v-if="column.config && column.config.is_show_maps"
        :class="{'w-100': !useDragIcon}"
        class="map-preview"
      >
        <img src="@/assets/new-form-ui/map-dummy.png">
      </div>
    </div>

    <!-- Custom HTML -->
    <div
      v-else-if="column.type === 'custom_html'"
      class="field-preview"
    >
      <div
        v-if="column.config"
        :class="{'w-100': !useDragIcon}"
        class="html-preview"
        v-html="decodeHtmlEntities(column.config.html)"
      />
      <span v-else>No configuration</span>
    </div>

    <!-- Field Group Preview -->
    <div
      v-else-if="column.type === 'group'"
      class="field-preview">
      <div
        :class="{'w-100': !useDragIcon}"
        class="group-preview"
      >
        <div class="group-preview-header">
          <span class="index">1</span>
          <div />
        </div>
        <div
          v-if="column.config && column.config.data_field_group"
          class="group-preview-container">
          <div
            v-for="item in column.config.data_field_group"
            :key="item.field_ui_key">
            <span>{{ item.name }}</span>
            <div
              :class="{'w-100': !useDragIcon}"
              class="input-preview text-preview"
            >
              <span>{{ `${item.placeholder || ''}` }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Field Table Group Preview -->
    <div
      v-else-if="column.type === 'table_group'"
      class="field-preview">
      <div class="group-preview">
        <table class="table table-bordered">
          <thead>
            <tr>
              <template v-if="column.config && column.config.data_field_group">
                <th
                  v-for="item in column.config.data_field_group"
                  :key="item.field_ui_key"
                  class="text-center">{{ item.name }}</th>
              </template>
              <th
                class="text-center"
                style="width: 100px">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <template v-if="column.config && column.config.data_field_group">
                <td
                  v-for="item in column.config.data_field_group"
                  :key="item.field_ui_key">
                  <div
                    :class="{'w-100': !useDragIcon}"
                    class="input-preview text-preview"
                  >
                    <span>{{ `${item.placeholder || ''}` }}</span>
                  </div>
                </td>
              </template>
              <td/>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Field Dynamic Field Preview -->
    <div
      v-else-if="column.type === 'dynamic_field'"
      class="field-preview">
      <div class="group-preview">
        <div class="group-preview-container">
          <div
            v-for="n in 2"
            :key="n">
            <span>Label</span>
            <div class="input-preview text-preview">
              <span>{{ `${column.placeholder || ''}` }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Field Code Editor Preview -->
    <div
      v-else-if="column.type === 'code_editor'"
      class="field-preview">
      <div
        :class="{'w-100': !useDragIcon}"
        class="code-editor-preview"
      >
        <div class="code-editor-preview-container">
          <span>1</span>
          <div/>
        </div>
      </div>
    </div>

    <!-- Field Digital Signature Preview -->
    <div
      v-else-if="column.type === 'digital_signature'"
      class="field-preview"
    >
      <div
        :class="{'w-100': !useDragIcon}"
        class="digital-signature-preview"
      />
    </div>

    <!-- Field Separator Preview -->
    <div
      v-else-if="column.type === 'separator'"
      class="field-preview"
    >
      <div
        :class="{'w-100': !useDragIcon}"
        class="separator-preview"
      />
    </div>

    <!-- Slider -->
    <div
      v-else-if="column.type === 'slider'"
      class="field-preview"
    >
      <div class="slider-preview">
        <input
          value="1"
          type="range"
          min="1"
          max="12"
        >
      </div>
    </div>

    <!-- Text Label -->
    <div
      v-else-if="column.type === 'text_label'"
      class="field-preview"
    >
      <div class="text-label-preview">
        <div
          :class="{
            'style-bold': column.config && column.config.style_label.font.includes('bold'),
            'style-italic': column.config && column.config.style_label.font.includes('italic'),
            'style-underline':
              column.config && column.config.style_label.font.includes('underline'),
            'style-left': column.config && column.config.style_label.alignment === 'left',
            'style-center': column.config && column.config.style_label.alignment === 'center',
            'style-right': column.config && column.config.style_label.alignment === 'right',
          }"
        >
          <h1 v-if="column.config && column.config.style_label.heading === 'h1'">
            This text will contain the selected column record data
          </h1>
          <h2 v-else-if="column.config && column.config.style_label.heading === 'h2'">
            This text will contain the selected column record data
          </h2>
          <h3 v-else-if="column.config && column.config.style_label.heading === 'h3'">
            This text will contain the selected column record data
          </h3>
          <h4 v-else-if="column.config && column.config.style_label.heading === 'h4'">
            This text will contain the selected column record data
          </h4>
          <h5 v-else-if="column.config && column.config.style_label.heading === 'h5'">
            This text will contain the selected column record data
          </h5>
          <h6 v-else-if="column.config && column.config.style_label.heading === 'h6'">
            This text will contain the selected column record data
          </h6>
          <div v-else>
            This text will contain the selected column record data
          </div>
        </div>
      </div>
    </div>

    <!-- Progress Bar -->
    <div
      v-else-if="column.type === 'progress_bar'"
      class="field-preview"
    >
      <div class="progress-bar-preview">
        <b-progress
          :max="100"
          class="mt-1"
        >
          <b-progress-bar
            :value="40"
            :style="`background-color: ${ column.config && column.config.color ? column.config.color : '#2487E1' } !important`"
            variant="primary">
            40%
          </b-progress-bar>
          <b-progress-bar
            :value="60"
            style="background-color: #D3D3D3 !important"
            variant="secondary"/>
        </b-progress>
        <div class="label-progress-bar">
          <div>0%</div>
          <div>50%</div>
          <div>100%</div>
        </div>
      </div>
    </div>

    <!-- Field Preview -->
    <div
      v-else
      class="field-preview"
    >
      <div
        :class="[
          setPreviewType(column.type),
          {'w-100': !useDragIcon}
        ]"
        class="input-preview"
      >
        <span>{{ `${column.placeholder || ''}` }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import he from 'he';

export default {
  props: {
    useDragIcon: {
      type: Boolean,
      default: true,
    },
    column: {
      type: Object,
      default: () => null,
    },
  },

  methods: {
    setPreviewType(type) {
      let classType = '';

      if (
        type === 'text' || type === 'number' || type === 'number_decimal' ||
        type === 'currency' || type === 'single_selection' || type === 'multiple_selection' ||
        type === 'user_single_selection' || type === 'password' || type === 'date' || type === 'time' ||
        type === 'date_time' || type === 'single_tags_selection' || type === 'multiple_tags_selection'
      ) {
        classType = 'text-preview';
      } else if (type === 'descriptive') {
        classType = 'textarea-preview';
      } else if (type === 'text_editor') {
        classType = 'texteditor-preview';
      } else if (type.includes('attachment')) {
        classType = 'attachment-preview';
      }

      return classType;
    },

    decodeHtmlEntities(str) {
      return he.decode(str);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/partials/FieldPreview.vue